import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('app.grouping'),
      path: 'configurations',
      use_parent_params: true,
      // params_required: ['id'],
      registerNavFromMenu: true,
      sc: [
        {
          name: i18n.t('grouping.companies'),
          path: 'configurations/grouping/companies/main',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('grouping.locations'),
          path: 'configurations/grouping/locations/main',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('grouping.agencies'),
          path: 'configurations/grouping/agencies/main',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('grouping.values'),
          path: 'configurations/grouping/values/main',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ]
    }
  ]
}
